import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const assignLicense = createAsyncThunk("assignLicense", async ({ licenseId, data, form }, { rejectWithValue }) => {
	const payload = {
		assigneeType: data.assigneeType,
		userId: data.assigneeType === "USER" ? data.userId : null,
		deviceAssetId: data.assigneeType === "ASSET" ? Number(data.deviceAssetId) : null,
		assignedDate: data.assignedDate ? data.assignedDate.format("YYYY-MM-DD") : new Date().toISOString().split("T")[0],
		expiryDate: data.expiryDate ? data.expiryDate.format("YYYY-MM-DD") : null,
	};

	try {
		const response = await axiosHttp.post(`assets/licenses/${licenseId}/assignments`, payload);
		form.resetFields();
		message.success("License assigned successfully!");
		return response.data?.data ?? response.data;
	} catch (e) {
		const msg = e?.response?.data?.message || "Could not assign the license";
		message.error(msg);
		return rejectWithValue(msg);
	}
});

export const revokeLicenseAssignment = createAsyncThunk("revokeLicenseAssignment", async ({ licenseId, assignmentId }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`assets/licenses/${licenseId}/assignments/${assignmentId}`);
		message.success("Assignment revoked successfully!");
		return response.data?.data ?? response.data;
	} catch (e) {
		const msg = e?.response?.data?.message || "Could not revoke the assignment";
		message.error(msg);
		return rejectWithValue(msg);
	}
});

const LicenseAssignmentSlice = createSlice({
	name: "licenseAssignmentSlice",
	initialState: { isLoading: false, error: null },
	extraReducers: (builder) => {
		builder
		.addCase(assignLicense.pending, (state) => { state.isLoading = true; })
		.addCase(assignLicense.fulfilled, (state) => { state.isLoading = false; })
		.addCase(assignLicense.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
		
		.addCase(revokeLicenseAssignment.pending, (state) => { state.isLoading = true; })
		.addCase(revokeLicenseAssignment.fulfilled, (state) => { state.isLoading = false; })
		.addCase(revokeLicenseAssignment.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
	},
});

export default LicenseAssignmentSlice.reducer;
